import {
	Instant,
	type LocalDate,
	TemporalAdjusters,
	type ZonedDateTime,
	ZoneOffset,
} from "@js-joda/core";
import type { PostDto } from "shared";
import { getUserWeekStart } from "../time/time";

export const daysBetween = (from: LocalDate, to: LocalDate) => {
	const days = [];
	let current = from;
	while (!current.isAfter(to)) {
		days.push(current);
		current = current.plusDays(1);
	}

	return days;
};

export function getMonthRange(date: LocalDate) {
	const from = date.with(TemporalAdjusters.firstDayOfMonth());

	const to = date.with(TemporalAdjusters.lastDayOfMonth());

	return daysBetween(from, to);
}

export function isDateInRange(date: LocalDate, haystack: LocalDate[]) {
	return haystack.some((x) => x.isEqual(date));
}

export const getMonthGridDays = (date: LocalDate) => {
	const startOfWeek = getUserWeekStart();
	const endOfWeek = startOfWeek.plus(6);

	const from = date
		.with(TemporalAdjusters.firstDayOfMonth())
		.with(TemporalAdjusters.previousOrSame(startOfWeek));

	const to = date
		.with(TemporalAdjusters.lastDayOfMonth())
		.with(TemporalAdjusters.nextOrSame(endOfWeek));

	return daysBetween(from, to);
};

export const getWeekGridDays = (date: LocalDate) => {
	const startOfWeek = getUserWeekStart();
	const endOfWeek = startOfWeek.plus(6);

	const weekStart = date.with(TemporalAdjusters.previousOrSame(startOfWeek));
	const weekEnd = date.with(TemporalAdjusters.nextOrSame(endOfWeek));

	return daysBetween(weekStart, weekEnd);
};

export function getWeekdays() {
	const startOfWeek = getUserWeekStart();
	const days = [startOfWeek];

	let day = startOfWeek.plus(1);
	while (!day.equals(startOfWeek)) {
		days.push(day);
		day = day.plus(1);
	}

	return days;
}

export function getPostDate(post: PostDto): ZonedDateTime {
	return Instant.parse(
		post.publishedAt ?? post.scheduledAt ?? post.updatedAt,
	).atZone(ZoneOffset.SYSTEM);
}
